// Splits a raw keyword string (typed or pasted) into independent keyword
// tokens: split on commas and newlines, strip a single pair of wrapping
// quotes, trim, drop empties, and dedupe while preserving order. Lets users
// paste quoted CSV like `"plastic", "plastic packaging", "PET"` and have it
// land as separate keywords. The filters search-button feature carries an
// identical `parseKeywordInput` (co-located, not shared, per the client
// import rules).
export const parseKeywordInput = (raw: string): string[] => {
  const tokens = raw
    .split(/[,\r\n]/)
    .map((token) => token.trim().replace(/^"|"$/g, '').trim())
    .filter((token) => token.length > 0)

  return Array.from(new Set(tokens))
}
